import { makeStyles, Theme } from '@material-ui/core/styles'
import { productCardBadge, transition } from '../../shared/style-settings'
import { createStyles } from '@material-ui/core'

// @ts-ignore
export const useListedItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: theme.shape.borderRadius * 2,
      border: `1px solid ${theme.palette.divider}`,
      transition: transition,
      overflow: 'hidden',
      '&:hover': {
        borderColor: theme.palette.primary.main,
        transform: 'translateY(-4px)',
      },
    },
    cardContent: {
      padding: theme.spacing(2.5),
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      '&:last-child': {
        paddingBottom: theme.spacing(2.5),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
        '&:last-child': {
          paddingBottom: theme.spacing(2),
        },
      },
    },
    cardHeader: {
      position: 'relative',
      marginBottom: theme.spacing(1.5),
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
    },
    imgHolder: {
      width: '100%',
      paddingBottom: '98.5%', // Now makes the 206.85px height per image, makes the look consistent
      position: 'relative',
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    link: {
      display: 'block',
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
      transition: transition,
      '&:hover': {
        transform: 'scale(1.02)',
      },
      '& img': {
        display: 'block',
        width: '100%',
        height: 'auto',
        transition: transition,
      },
      '&:hover img': {
        transform: 'scale(1.05)',
      },
      '& div:not(.MuiCircularProgress-root):not([data-image-overlay])': {
        height: 'auto !important',
        width: '100% !important',
      },
    },
    noneTextDecoration: {
      textDecoration: 'none',
    },
    productTitleLink: {
      display: 'block',
      textAlign: 'left',
    },
    productTitle: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: 0,
      marginBottom: theme.spacing(0.5),
      lineHeight: 1.3,
      fontSize: '1.125rem',
      fontWeight: 600,
      color: theme.palette.text.primary,
      transition: transition,
      [theme.breakpoints.down('md')]: {
        fontSize: '1rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9375rem',
      },
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    productPropertyLine: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(0.25),
      '&:last-child': {
        marginBottom: 0,
      },
    },
    productPropertyLineOffset: {
      marginTop: theme.spacing(0.25),
    },
    propertyValue: {
      color: theme.palette.text.primary,
      fontWeight: 700,
      fontSize: '1.0625rem',
      lineHeight: 1.25,
      marginTop: theme.spacing(0.75),
      marginBottom: theme.spacing(0.5),
      [theme.breakpoints.down('md')]: {
        fontSize: '0.9375rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.875rem',
      },
    },
    iconWrapper: {
      position: 'absolute',
      top: '34%',
      marginTop: -5,
      transformOrigin: 'center center',
      transform: 'scale(0.8)',
      left: 0,
      right: 0,
      opacity: 0.1,
    },
    cityRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      width: '100%',
      minWidth: 0,
    },
    locationIcon: {
      fontSize: '1rem',
      color: theme.palette.text.secondary,
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: '0.9rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.85rem',
      },
    },
    cityValue: {
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
      marginTop: 0,
      fontWeight: 400,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.8125rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.75rem',
      },
    },
    conditionLabel: {
      color: theme.palette.grey['A700'],
      fontSize: 14,
      fontWeight: 600,
      [theme.breakpoints.down('md')]: {
        fontSize: 13,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    conditionValue: {
      fontSize: productCardBadge.fontSize,
      lineHeight: productCardBadge.lineHeight,
      marginTop: 0,
      marginLeft: theme.spacing(0.5),
      fontWeight: productCardBadge.fontWeightInline,
      display: 'inline-block',
      padding: theme.spacing(
        productCardBadge.inlinePaddingY,
        productCardBadge.inlinePaddingX
      ),
      borderRadius: theme.shape.borderRadius,
      textTransform: productCardBadge.textTransform,
      letterSpacing: productCardBadge.letterSpacing,
      [theme.breakpoints.down('md')]: {
        fontSize: '0.5625rem',
        padding: theme.spacing(0.1, 0.4),
        letterSpacing: '0.28px',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.5rem',
        padding: theme.spacing(0.08, 0.35),
        letterSpacing: '0.25px',
      },
    },
    conditionValueNew: {
      color: theme.palette.common.white,
      background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
    },
    conditionValueUsed: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.grey[600],
    },
    dateBlock: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
      marginTop: theme.spacing(1.5),
      gap: theme.spacing(0.5),
      '&[data-hidden="true"]': {
        visibility: 'hidden',
      },
    },
    dateBlockValue: {
      fontWeight: 600,
      color: theme.palette.grey['700'],
    },
    orderStatusBlock: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.grey['A200'],
      fontSize: 14,
    },
    orderInfoRow: {
      width: '100%',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
    },
    orderStatusBlockValue: {
      fontWeight: 600,
      color: theme.palette.grey['700'],
      textAlign: 'right',
    },
    dateLabel: {
      display: 'block',
      marginRight: 0,
      fontWeight: 500,
    },
  })
)
